module.exports = __webpack_public_path__ + "static/media/mobile-banner-black.22879625.png";